module.exports = __webpack_public_path__ + "img/os_icon.451482a5.svg";